import React, { ReactNode } from 'react';

interface CardFooterProps {
  children: ReactNode;
  className?: string;
  border?: boolean;
}

const CardFooter: React.FC<CardFooterProps> = ({
  children,
  className = '',
  border = true
}) => {
  const borderClass = border ? 'border-t border-border-light dark:border-border-medium' : '';

  return (
    <div className={`p-4 ${borderClass} ${className}`}>
      {children}
    </div>
  );
};

export default CardFooter;